import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    RatingGroupAll: [],
    loading: false,
    error: null,
}

const RatingGroupAllSlice = createSlice({
    name: "RatingGroupAll",
    initialState,
    reducers: {
        fetchRatingGroupAllStart: (state) => {
            state.loading = true;
            state.error = null;
        },
        fetchRatingGroupAllSuccess: (state, action) => {
            state.loading = false,
                state.RatingGroupAll = action.payload;
        },
        fetchRatingGroupAllFailure: (state, action) => {
            state.loading = false,
                state.error = action.payload;
        },
    },
})
export const {
    fetchRatingGroupAllStart,
    fetchRatingGroupAllSuccess,
    fetchRatingGroupAllFailure,
} = RatingGroupAllSlice.actions;

export default RatingGroupAllSlice.reducer;